/**
 * Admin SPA → API auth: mint JWT with backend ADMIN_API_KEY, store for Bearer deletes.
 * Set REACT_APP_ADMIN_API_KEY in .env.local (same value as server ADMIN_API_KEY) for admin tools.
 */

import store from '../store';
import { logout, setJwt } from '../store/slices/authSlice';

const TOKEN_KEY = 'vardaan_admin_jwt';

export function getApiRootFromBlogsUrl(blogsUrl) {
  const u = String(blogsUrl || '').replace(/\/$/, '');
  return u.replace(/\/api\/blogs$/, '');
}

export function getStoredAdminJwt() {
  try {
    return store.getState().auth.jwt || '';
  } catch {
    return '';
  }
}

export function setStoredAdminJwt(token) {
  try {
    if (token) store.dispatch(setJwt(token));
  } catch {
    /* ignore */
  }
}

export function clearStoredAdminJwtForLogout() {
  try {
    store.dispatch(logout());
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function blogAuthHeaders() {
  const t = getStoredAdminJwt();
  if (!t) return {};
  return { Authorization: `Bearer ${t}` };
}

/**
 * POST /api/auth/token with x-admin-key; stores JWT when body.returnToken is supported.
 */
export async function mintAdminJwtFromEnv(blogsApiUrl) {
  const adminKey = process.env.REACT_APP_ADMIN_API_KEY;
  if (!adminKey || !blogsApiUrl) return false;
  const root = getApiRootFromBlogsUrl(blogsApiUrl);
  const tokenUrl = `${root}/api/auth/token`;
  try {
    const res = await fetch(tokenUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-admin-key': adminKey
      },
      body: JSON.stringify({ role: 'admin', returnToken: true })
    });
    const data = await res.json().catch(() => ({}));
    if (data.success && data.token) {
      setStoredAdminJwt(data.token);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

export function mergeBlogAuthHeaders(headers = {}) {
  const out = { ...headers, ...blogAuthHeaders() };
  const k = process.env.REACT_APP_ADMIN_API_KEY;
  if (k) out['x-admin-key'] = k;
  return out;
}
